/* begin general import */
import { Model } from "@react3l/react3l/core/model";
import Modal from "components/Utility/Modal/Modal";
import { TFunction } from "i18next";
import React from "react";
/* end general import */
/* begin individual import */
/* end individual import */
import { Col, Row, Table } from "antd";
import { ColumnProps } from "antd/lib/table";
import classNames from "classnames";
import { Device } from "models/Device";
import { Moment } from "moment";
import { formatDate } from "helpers/date-time";

interface DevicePreviewProps<T extends Model> {
  previewModel?: T;
  isOpenPreview?: boolean;
  isLoadingPreview?: boolean;
  handleClosePreview?: () => void;
  translate?: TFunction;
}
function DeviceTypeDetailModal(props: DevicePreviewProps<Device>) {
  const {
    previewModel,
    isOpenPreview,
    isLoadingPreview,
    handleClosePreview,
  } = props;
  const baseDeviceColumns: ColumnProps<Device>[] = [
    {
      title: <div className="gradient-text text-upper">MAC</div>,
      key: "0",
      dataIndex: "macAddress",
      width: 200,
      render(id: string) {
        return (
          <div className="ant-cell-master__container">
            <div
              className={classNames("cell-master__first-row", {
                "first-row--ellipsis": true,
              })}
            >
              {id}
            </div>
          </div>
        );
      },
    },
    {
      title: <div className="gradient-text text-upper">Thời gian tạo</div>,
      key: "1",
      dataIndex: "createdAt",
      width: 200,
      render(createdAt: Moment) {
        return (
          <div className="ant-cell-master__container">
            <div
              className={classNames("cell-master__first-row", {
                "first-row--ellipsis": true,
              })}
            >
              {formatDate(createdAt)}
            </div>
          </div>
        );
      },
    },
    {
      title: <div className="gradient-text text-upper">FW Version</div>,
      key: "firmwareVersion",
      dataIndex: "firmwareVersion",
      width: 150,
      render(firmwareVersion: string) {
        return (
          <div className="ant-cell-master__container">
            <div className="cell-master__first-row">{firmwareVersion}</div>
          </div>
        );
      },
    },
  ];
  const deviceColumns: ColumnProps<Device>[] = [
    ...baseDeviceColumns,
    ...(previewModel && previewModel.deviceTypeId === 51002
      ? [
        {
          title: <div className="gradient-text text-upper">Dormitory ID</div>,
          key: "dormitoryId",
          dataIndex: "dormitoryId",
          width: 150,
          render(dormitoryId: any) {
            return (
              <div className="ant-cell-master__container">
                <div
                  className={classNames("cell-master__first-row", {
                    "first-row--ellipsis": true,
                  })}
                >
                  {dormitoryId}
                </div>
              </div>
            );
          },
        },
        {
          title: <div className="gradient-text text-upper">Thời gian kích hoạt</div>,
          key: "activationTime",
          dataIndex: "activationTime",
          width: 200,
          render(activationTime: string) {
            return (
              <div className="ant-cell-master__container">
                <div
                  className={classNames("cell-master__first-row", {
                    "first-row--ellipsis": true,
                  })}
                >
                  {/* {activationTime} */}12/05/2025
                </div>
              </div>
            );
          },
        },
        {
          title: <div className="gradient-text text-upper">Bảo hành</div>,
          key: "warranty",
          dataIndex: "warranty", // Sẽ lấy từ dataSource được tạo riêng
          width: 150,
          render(warranty: string) {
            return (
              <div className="ant-cell-master__container">
                <div className="cell-master__first-row">
                  {/* {warranty} */}12/05/2028
                  </div>
              </div>
            );
          },
        },
      ]
      : []),
  ];
  return (
    <>
      <Modal
        title={null}
        visible={isOpenPreview}
        handleCancel={handleClosePreview}
        width={1200}
        visibleFooter={false}
      >
        {isLoadingPreview ? (
          <div className="loading-block">
            <img src="/assets/images/spinner.svg" alt="Loading..." />
          </div>
        ) : (
          <div className="preview__containter">
            <div className="preview__left-side">
              <div className="preview__header">
                <div className="preview__vertical-bar"></div>
                <div className="preview__header-info">
                  <div className="preview__header-text">
                    <span className="preview__header-title">
                    </span>
                  </div>
                </div>
              </div>
              <div className="preview__body">
                <div className="preview__content">

                  <Col>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={24}>
                        <div className="table__container w-100">
                          <div className="table__header w-100 d-flex justify-content-between">
                            <span className="card-title">{previewModel.name}</span>
                          </div>
                          <div className="table__content">
                            <Table
                              rowKey={"id"}
                              columns={deviceColumns}
                              pagination={false}
                              dataSource={previewModel ? [previewModel] : []}
                              rowSelection={null}
                              scroll={{ y: 400, x: "max-content" }}
                            ></Table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                </div>
              </div>
              <div className="preview__footer"></div>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
export default DeviceTypeDetailModal;
